import React, { Component, lazy } from 'react'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'
import LoadingSpinner from '../components/partials/LoadingSpinner'
import ReactGA from 'react-ga4'
import AuthService from '../services/AuthService'
import { IS_FROM_CONNECT_APP, LOCAL_STORAGE_SOURCE, LOCAL_STORAGE_USER_EMAIL } from '../config/constants'
import store from 'store'
import i18next from 'i18next'
import { SignUpRoute } from './SignUpRoute'

const HomeComponent = lazy(() => import('../components/Home'))
const SignUpContainer = lazy(() => import('../containers/SignUpContainer'))
const DesktopExpeditedSignUpContainer = lazy(() => import('../containers/DesktopExpeditedSignUpContainer'))
const QrScannedComponent = lazy(() => import('../components/QrScannedComponent'))
const QrPatientStudy = lazy(() => import('../components/QrPatientStudy'))
const QrMedicalProfessional = lazy(() => import('../components/QrMedicalProfessional'))

const auth = new AuthService()

const handleAuthentication = (nextState, replace) => {
  if (/access_token|id_token|error/.test(nextState.location.hash)) {
    auth.handleAuthentication()
  }
}

const PublicRoute = ({ component: Component, ...rest }) => {
  return (
    <Route {...rest} render={(props) => (<Component {...props} />)} />
  )
}

class UnifiedRoutesContainer extends Component {
  constructor(props) {
    super(props);

    if (props?.history?.location?.pathname) {
      ReactGA.send({hitType: "pageview", page: props.history.location.pathname});
    }

    ReactGA.event({
      category: "Custom testing event",
      action: "testing action",
    });
  }
  
  componentDidMount() {
    const params = new URLSearchParams(this.props.location.search)
    const paramsObject = {};
    params.forEach((value, key) => {
      paramsObject[key] = value;
    });
    const src = params.get("src");
    if (src) {
      store.set(LOCAL_STORAGE_SOURCE, src);
    }
    const email = params.get("email");
    if (email) {
      store.set(LOCAL_STORAGE_USER_EMAIL, email);
    }
    const isFromConnectApp = params.get("redirect-from-connect-app");
    if (isFromConnectApp) {
      store.set(IS_FROM_CONNECT_APP, isFromConnectApp);
    }
    const locale = params.get("locale");
    if (locale) {
      i18next.changeLanguage(locale);
      store.set('selectedLanguage', locale);
    }
  }

  componentDidUpdate(props) {
    if (props?.history?.location?.pathname) {
      ReactGA.send({hitType: "pageview", page: props.history.location.pathname});
    }
  }

  render () {
    return (
      <Switch>
        <Route exact path='/auth0-callback' render={(props) => {
          handleAuthentication(props)
          return <LoadingSpinner {...props} />
        }} />
        <PublicRoute exact path='/' component={HomeComponent} />
        <Route exact path='/signup/' render={(props) => {
          return <Redirect to={`/signup/user-type`} />
        }} />
        <Route exact path='/expedited-signup/' render={(props) => {
          return <Redirect to={`/expedited-signup/user-type${props.location.search}`} />
        }} />
        <PublicRoute exact path='/expedited-signup/:currentPage' component={DesktopExpeditedSignUpContainer} />
        <SignUpRoute exact path='/signup/:currentPage' component={SignUpContainer} />
        <PublicRoute exact path='/qr-scanned' component={QrScannedComponent} />
        <PublicRoute exact path='/qr-scanned-patient' component={QrPatientStudy} />
        <PublicRoute exact path='/qr-scanned-medical-professional' component={QrMedicalProfessional} />
        <PublicRoute exact path='/share-link' component={QrMedicalProfessional} />
      </Switch>
    )
  }
}

export default withRouter(UnifiedRoutesContainer) 